import "@atg-shared/micro-frontend/setPublicPath";
import {configureStoreForAuthentication} from "@atg-shared/auth";
import {initialiseLanguage} from "@atg-shared/language";
import {initLogger} from "@atg-shared/log";
import {configureEmotionCache} from "atg-emotion-cache";

import {store as sportsbookStore} from "./store";

initLogger({
    application: "atg-web-sportsbook",
    logLevel: process.env.NODE_ENV !== "production" ? "info" : "warn",
});
configureStoreForAuthentication(sportsbookStore);
configureEmotionCache("sportsbook");

initialiseLanguage(async (locale) => {
    const {messages} = await import(
        /* webpackChunkName: "i18n" */ `../locales/${locale}/messages.po`
    );
    return messages;
});

export const App = () => import(/* webpackChunkName: "App" */ "./components/App/App");

export const SideMenu = () =>
    import(/* webpackChunkName: "SideMenu" */ "./components/SideMenu/SideMenu");

export const SportpoolBetHistory = () =>
    import(
        /* webpackChunkName: "SportpoolBetHistory" */ "./components/SportpoolBetHistory/SportpoolBetHistory"
    );

export const SportbookBetHistory = () =>
    import(
        /* webpackChunkName: "SportbookBetHistory" */ "./components/SportbookBetHistory/SportbookBetHistory"
    );
